import { h, render, Component } from 'preact';
import TxrNavbar from './txr-navbar';
import { classNames } from '../utils/utils';

class TxrExpandItem extends Component {
    state = {
        isExpanded: false
    }
    toggle = () => {
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    createMarkupContent = () => {
        return { __html: this.props.content };
    }
    render() {
        return (
            <div class={'txr-expand-item' + (this.state.isExpanded ? ' txr-expand-item__expanded' : '')}>
                <div class="txr-expand-item__header" onClick={() => this.toggle()} >
                    <h3 class="txr-expand-item-header__title txr-h">{this.props.header}</h3>
                    <i class="txr-expand-item-header__toggler fal fa-angle-up"></i>
                </div>
                <div class="txr-expand-item__content">
                    <div class="txr-expand-item__content-padding" dangerouslySetInnerHTML={this.createMarkupContent()}>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrExpandItem;